/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorWorkspaceApproveLogDto } from '../../models/update-vendor-workspace-approve-log-dto';
import { VendorWorkspaceApproveLogDto } from '../../models/vendor-workspace-approve-log-dto';

export interface VendorWorkspaceApproveLogControllerUpdate$Params {
  id: string;
      body: UpdateVendorWorkspaceApproveLogDto
}

export function vendorWorkspaceApproveLogControllerUpdate(http: HttpClient, rootUrl: string, params: VendorWorkspaceApproveLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceApproveLogControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceApproveLogDto>;
    })
  );
}

vendorWorkspaceApproveLogControllerUpdate.PATH = '/api/vendorWorkspaceApproveLog/{id}';
